export default __webpack_public_path__ + "static/media/cel.bd4d0f5a.png";